import { FiList } from "react-icons/fi";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const fmt = require("indian-number-format");

export default function TopHeader({ isDollar }) {
  const navigate = useNavigate();
  const total = useSelector((state) => state.total);

  const color =
    total > 0
      ? "text-[var(--buymeta)]"
      : total < 0
        ? "text-[var(--sellmeta)]"
        : "text-[var(--text)]";

  const hasSymbolData = window.symboldata || localStorage.getItem("symboldata");

  return (
    <div className="flex justify-between items-center px-5 pt-4">
      {/* ➕ Buy/Sell Button */}
      {hasSymbolData && (
        <button className="p-2 transition">
          <FiList className="w-6 h-6 text-[var(--text)]" />
        </button>
      )}
      {/* 💰 Total */}
      <div className="text-lg font-semibold select-none">
        <span className={`${color}`}>
          {fmt.format(total.toFixed(2))} {isDollar === 1 ? "USD" : "INR"}
        </span>
      </div>

      {/* ➕ Buy/Sell Button */}
      {hasSymbolData && (
        <button
          onClick={() => navigate("/BuySell")}
          className="w-10 h-10 flex items-center justify-center rounded-full 
                     bg-[var(--background)] backdrop-[var(--background)]-md hover:shadow-lg 
                     transition-transform duration-150 active:scale-95 hover:scale-105"
        >
          <Plus className="text-[22px] text-[var(--text)]" />
        </button>
      )}
    </div>
  );
}
